<style lang="less">
    .color-sucker-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 360;
        .color-sucker {
            position: fixed;
            border-radius: 50%;
            width: 121px;
            height: 121px;
            box-sizing: content-box;
            border: 1px solid black;
            z-index: 361;
            overflow: hidden;
            background-color: white;
            .color-sucker-row {
                .color-sucker-col {
                    float: left;
                    width: 11px;
                    height: 11px;
                    border-right: 1px solid #e0e0e0;
                    border-bottom: 1px solid #e0e0e0;
                }
                .active {
                    border-color: black;
                }
                .active-bot {
                    border-bottom-color: black;
                }
                .active-right {
                    border-right-color: black;
                }
            }
            > span {
                color: white;
                border-radius: 4px;
                font-size: 12px;
                position: absolute;
                background-color: #888888;
                text-align: center;
                padding: 0 4px;
                display: block;
                left: 50%;
                top: 73%;
                transform: translate(-50%, -50%);
            }
        }
    }
</style>

<template>
    <div class="color-sucker-mask" :style="{ cursor: `url(${cursorSource}) 10.5 10.5, auto !important` }">
        <div class="color-sucker" :style="{ top: colorSuckerConPos.top + 'px', left: colorSuckerConPos.left + 'px' }">
            <div class="color-sucker-row" v-for="row in 11">
                <div
                    class="color-sucker-col"
                    v-for="col in 11"
                    :style="suckedColor(row, col)"
                    :class="{ active: row === 6 && col === 6, 'active-bot': row === 5 && col === 6, 'active-right': row === 6 && col === 5 }"
                ></div>
            </div>
            <span v-text="chosenSuckerColor"></span>
        </div>
    </div>
</template>

<script lang="ts">
    declare var UnitUtil: any;
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class ColorSucker extends Vue {
        // 初始数据可以直接声明为实例的属性
        tempX: number = 0;
        tempY: number = 0;
        offsetX: number = 0;
        offsetY: number = 0;
        cursorSource = require("@/app/assets/cursorSucker.svg");

        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft;
        }
        get colorSuckerMatrix() {
            return this.$store.state.ui.colorSuckerMatrix;
        }
        get colorSuckerConPos() {
            return this.$store.state.ui.colorSuckerConPos;
        }
        get chosenSuckerColor() {
            if (this.colorSuckerMatrix.length) {
                let pixel = this.colorSuckerMatrix[5][5];
                // let alpha = pixel[3]/255;
                // let r = Math.round(pixel[0]*alpha).toString(16);
                // r = r.length == 1?"0"+r:r
                // let g = Math.round(pixel[1]*alpha).toString(16);
                //     g = g.length == 1?"0"+g:g
                // let b = Math.round(pixel[2]*alpha).toString(16);
                //     b = b.length == 1?"0"+b:b
                return "#" + pixel.toUpperCase();
            } else {
                return "#FFFFF";
            }
        }
        get showColorSucker() {
            return this.$store.state.ui.showColorSucker;
        }
        set showColorSucker(v) {
            this.$store.commit("setStatus", {
                type: "showColorSucker",
                data: v,
            });
        }
        canvasMove(e) {
            if (this.showColorSucker) {
                let rect = document.getElementById("scene").getBoundingClientRect();

                this.$store.commit("setStatus", {
                    type: "colorSuckerConPos",
                    data: {
                        top: e.pageY + 10,
                        left: e.pageX + 10,
                    },
                });
                let x = e.pageX;
                let y = e.pageY;
                if (e.cancelable) {
                    this.tempX = x;
                    this.tempY = y;
                    this.offsetX = 0;
                    this.offsetY = 0;
                }
                if (this.$store.state.ui.showLibrary) {
                    x = x - this.sceneLeft;
                }
                y = y - 93;

                let X = e.pageX;
                let Y = e.pageY;
                if (X > rect.left + 20 && X < rect.left + rect.width && Y > rect.top + 20 && Y < rect.top + rect.height) {
                    this.$store.commit("setStatus", {
                        type: "inScene",
                        data: true,
                    });
                } else {
                    this.$store.commit("setStatus", {
                        type: "inScene",
                        data: false,
                    });
                }

                let colorMatrix = this.getCanvasColor(x, y);
                this.$store.commit("setStatus", {
                    type: "colorSuckerMatrix",
                    data: colorMatrix,
                });
                colorMatrix = null;
            }
        }
        getCanvasColor(x, y) {
            x = x * UnitUtil.pixelRatio();
            y = y * UnitUtil.pixelRatio();
            let colorMatrix = [];
            let dataView = new DataView(
                (<HTMLCanvasElement>document.getElementById("mycanvas")).getContext("2d").getImageData(x - 5, y - 5, 11, 11).data.buffer
            );
            let bgDataView = new DataView(
                (<HTMLCanvasElement>document.getElementById("bgcanvas")).getContext("2d").getImageData(x - 5, y - 5, 11, 11).data.buffer
            );
            for (let i = 0; i < 11; i++) {
                colorMatrix[i] = [];
                for (let j = 0; j < 11; j++) {
                    let data = dataView.getUint32(4 * (j + i * 11));
                    if (!data) data = bgDataView.getUint32(4 * (j + i * 11));
                    let hexStr = data ? data.toString(16) : "e5e5e5ff";
                    if (hexStr.length < 8) {
                        hexStr = hexStr.padStart(8, "0");
                    }
                    colorMatrix[i][j] = hexStr.slice(0, 6);
                }
            }

            return colorMatrix;
        }
        keyMove(e: KeyboardEvent) {
            e.preventDefault();
            e.stopPropagation();
            if (e.keyCode >= 37 && e.keyCode <= 40) {
                if (e.keyCode === 37 || e.keyCode === 39) {
                    this.offsetX += e.keyCode - 38;
                } else if (e.keyCode === 38 || e.keyCode === 40) {
                    this.offsetY += e.keyCode - 39;
                }
                let event = new MouseEvent("mousemove", {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                    clientX: this.tempX + this.offsetX,
                    clientY: this.tempY + this.offsetY,
                });
                document.dispatchEvent(event);
            } else if (e.keyCode === 13) {
                this.ok();
            } else if (e.keyCode === 27) {
                this.close();
            }
        }

        suckedColor(row, col) {
            let x = row - 1,
                y = col - 1;
            if (x < this.colorSuckerMatrix.length && y < this.colorSuckerMatrix.length) {
                let pixel = this.colorSuckerMatrix[x][y];
                return {
                    backgroundColor: "#" + pixel,
                };
            }
        }
        ok(e?: MouseEvent) {
            e && e.stopPropagation();
            let rect = document.getElementById("scene").getBoundingClientRect();
            let sketchFuncName = "sketchOK";
            if (this.$store.state.dialog.sketchType) {
                sketchFuncName += this.$store.state.dialog.sketchType;
            }
            let changed = false;
            let x = this.tempX + this.offsetX;
            let y = this.tempY + this.offsetY;
            if (e) {
                if (e.button === 0 && x > rect.left && x < rect.left + rect.width && y > rect.top && y < rect.top + rect.height) {
                    changed = true;
                    this.$bus.$emit(sketchFuncName, this.chosenSuckerColor);
                } else if (e.button === 2 || e.button === 1) {
                    return;
                }
            } else {
                if (x > rect.left && x < rect.left + rect.width && y > rect.top && y < rect.top + rect.height) {
                    changed = true;
                    this.$bus.$emit(sketchFuncName, this.chosenSuckerColor);
                }
            }

            if (!e) {
                this.close();
            }
        }
        close() {
            let width = (<HTMLCanvasElement>document.getElementById("mycanvas")).width; //force refresh canvas
            (<HTMLCanvasElement>document.getElementById("mycanvas")).width = 0;
            (<HTMLCanvasElement>document.getElementById("mycanvas")).width = width;
            this.tempX = this.tempY = this.offsetX = this.offsetY = 0;
            window["_view"].invalidate(true);
            this.$store.commit("setStatus", {
                type: "showPalette",
                data: true,
            });
            this.$store.commit("toPalette", { type: null });
            this.$store.commit("setStatus", {
                type: "colorSuckerConPos",
                data: {
                    top: -1000,
                    left: -1000,
                },
            });

            this.$store.commit("setDialogState", {
                type: "sketchType",
                data: null,
            });
            this.showColorSucker = false;
            this.$store.commit("setStatus", {
                type: "inScene",
                data: true,
            });
        }
        //生命周期
        mounted() {}

        created() {
            let ts = this;
            window.addEventListener("mousedown", this.ok);
            window.addEventListener("mouseup", this.close);
            window.addEventListener("mousemove", this.canvasMove);
            window.addEventListener("keydown", this.keyMove);
        }
        beforeDestroy() {
            window.removeEventListener("mousedown", this.ok);
            window.removeEventListener("mouseup", this.close);
            window.removeEventListener("mousemove", this.canvasMove);
            window.removeEventListener("keydown", this.keyMove);
        }
    }
</script>
